import React from "react";

const DeleteAccount = () => {
  return (
    <>
      <style>
        {`
          body {
            margin: 0;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
              "Noto Sans KR", Arial, sans-serif;
            background: #f7f8fa;
            color: #222;
            line-height: 1.7;
          }

          .delete-account-container {
            max-width: 760px;
            margin: 40px auto;
            padding: 0 20px;
          }

          .delete-account-card {
            background: #fff;
            border-radius: 16px;
            padding: 32px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          }

          .delete-account-card h1 {
            margin-top: 0;
            font-size: 28px;
            font-weight: bold;
          }

          .delete-account-card h2 {
            margin-top: 32px;
            font-size: 20px;
            font-weight: bold;
          }

          .delete-account-path {
            background: #f1f3f5;
            padding: 12px 16px;
            border-radius: 8px;
            font-weight: 600;
            margin-top: 24px;
          }

          .delete-account-info {
            margin-top: 24px;
            padding: 16px;
            background: #f8f9fa;
            border-radius: 8px;
          }

          .delete-account-info a {
            color: #2563eb;
            text-decoration: none;
          }

          .delete-account-info a:hover {
            text-decoration: underline;
          }

          .delete-account-card ul {
            padding-left: 22px;
            list-style-type: disc;
            margin-top: 24px;
          }

          .delete-account-card p {
            margin-top: 24px;
          }
        `}
      </style>

      <div className="delete-account-container">
        <div className="delete-account-card">
          <h1>계정 및 데이터 삭제 안내</h1>

          <p>
            본 페이지는 <strong>안전관리플랫폼</strong> 사용자의 계정 및 관련 데이터 삭제 방법을 안내합니다.
          </p>

          <h2>계정 삭제 방법</h2>

          <p>
            사용자는 앱 내에서 다음 경로를 통해 계정 및 데이터 삭제를 요청할 수 있습니다.
          </p>

          <div className="delete-account-path">
            마이페이지 → 설정 → 회원탈퇴
          </div>

          <p>
            앱을 이용할 수 없거나 앱 내에서 직접 탈퇴하기 어려운 경우에는
            아래 이메일을 통해 계정 및 데이터 삭제를 요청할 수 있습니다.
          </p>

          <div className="delete-account-info">
            이메일:{" "}
            <a href="mailto:bmcsafety@bmc.busan.kr">
              bmcsafety@bmc.busan.kr
            </a>
          </div>

          <p>
            계정 및 데이터 삭제 요청 시 본인 확인을 위해 가입 시 사용한 ID 또는
            계정 정보를 요청할 수 있습니다.
          </p>

          <h2>삭제되는 데이터</h2>

          <p>
            계정 삭제가 완료되면 다음과 같은 계정 관련 정보가 삭제됩니다.
          </p>

          <ul>
            <li>회원 계정 정보</li>
            <li>이름, 연락처 등 회원 정보</li>
          </ul>

          <h2>일부 데이터의 보관</h2>

          <p>
            관련 법령에 따라 일정 기간 보관이 필요한 정보가 있는 경우,
            해당 데이터는 법에서 정한 기간 동안 별도로 보관된 후 삭제될 수 있습니다.
          </p>

          <p>보관 기간이 종료된 정보는 지체 없이 삭제됩니다.</p>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount;